import type { TextFieldProps } from "$components/inputs";
import { TextField } from "$components/rhf-fields";
import React from "react";
import { useIntl } from "react-intl";

/** @deprecated possible-component */
export const RHFTextField: React.FunctionComponent<
  Omit<TextFieldProps, "clearButtonTitle"> & { name: string }
> = (props) => {
  const { formatMessage } = useIntl();

  return (
    <TextField
      {...props}
      clearButtonTitle={formatMessage({
        id: "textField.clear",
        defaultMessage: "Clear",
      })}
    />
  );
};
